import React, { Component } from "react";
import {
  Pagination,
  PageHeader,
  Tabs,
  Tab,
  FormGroup,
  Form,
  FormControl,
  Button,
} from "react-bootstrap";
import { Box } from "reactjs-admin-lte";
import FixingOrderDoc from "../workdoc/jobcontrol/FixingOrderDoc";
import ReportStore from "../../stores/ReportStore";
import FontAwesome from "react-fontawesome";
import Select from "react-select";
import SelectDate from "../../component/element/SelectDate";
import { tableHelper, momentHelper } from "./helpers";

const searchOptions = [
  { label: "ทะเบียนรถ", value: "car_registration_no" },
  { label: "เลขที่ใบงานซ่อม", value: "work_no" },
  { label: "ชื่อช่าง", value: "mechanic_name" },
];
class ReportFixingOrderPage extends Component {
  constructor(...args) {
    super(...args);

    const month = momentHelper.getMonth();
    const year = momentHelper.getYear();
    const day = momentHelper.getDay();
    const searchBy = "car_registration_no";
    const query = "";

    this.state = {
      loading: false,
      showBox: "",
      showFixing: false,
      workNo: "",
      technician: {
        first_name: "",
        last_name: "",
        position: "",
        work_status: "",
        count_list: "",
        employee_id: "",
        gross_flag: "",
        nick_name: "",
        sum_cost: "",
      },
      data: { dataList: [] },
      month: month,
      year: year,
      day: "00",
      searchBy: searchBy,
      query: query,
      selectIndex: -1,
    };
  }

  componentDidMount() {
    let { year, month, day, query, searchBy } = this.state;
    this.loadData(year, month, day, query, searchBy);
  }

  loadData(year, month, day, q, cat) {
    let { data } = this.state;
    this.setState({ loading: true });
    ReportStore.loadReportFixingOrder(year, month, day, q, cat, (result) => {
      data.dataList = result.data;
      this.setState({ data: data, loading: false });
    });
  }

  onRowClick(item, index, e) {
    let { technician } = this.state;
    technician.first_name = item.name;
    technician.position = item.position;
    technician.employee_id = item.employee_id;
    technician.fixing_order_date = item.fixing_order_date;

    this.setState({
      showFixing: true,
      showBox: "none",
      workNo: item.work_no,
      technician: technician,
      selectIndex: index,
    });
  }

  onFixingBack(e) {
    this.setState({ showFixing: false, showBox: "", selectIndex: -1 });
  }

  renderRowData() {
    let { data } = this.state;
    if (data.dataList.length === 0 || data.dataList === undefined) {
      return (
        <tr>
          <td colSpan={9}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.dataList.map((item, index) => {
        return (
          <tr key={index} onClick={this.onRowClick.bind(this, item, index)}>
            <td className="text-center">{index + 1}</td>
            <td className="text-center">{item.fixing_order_date}</td>
            <td className="text-center">{item.work_no}</td>
            <td className="text-center">{item.car_registration_no}</td>
            <td className="text-center">{item.car_detail}</td>
            <td className="text-left">{item.name}</td>
            <td className="text-center">{item.position}</td>
            <td className="text-right">{item.total_cost}</td>
            <td className="text-right">{item.total_withdraw}</td>
            <td className="text-right">{item.balance}</td>
          </tr>
        );
      });
    }
  }

  renderTable() {
    return (
      <div className="table-responsive">
        <table
          className="table table-responsive table-hover table-bordered-solid"
          style={{ minWidth: "1300px" }}
        >
          <thead>
            <tr>
              <th className="text-center" style={{ width: "50px" }}>
                ลำดับ
              </th>
              <th className="text-center" style={{ width: "50px" }}>
                วันที่
              </th>
              <th className="text-center" style={{ width: "120px" }}>
                ใบงานซ่อม
              </th>
              <th className="text-center" style={{ width: "200px" }}>
                ทะเบียน
              </th>
              <th className="text-center" style={{ width: "90px" }}>
                ยี่ห้อ
              </th>
              <th className="text-center" style={{ width: "90px" }}>
                ชื่อช่าง
              </th>
              <th className="text-center" style={{ width: "90px" }}>
                ฝ่าย
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                ราคาเหมา
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                เบิกจ่าย
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                คงเหลือค้างจ่าย
              </th>
            </tr>
          </thead>
          <tbody>{this.renderRowData()}</tbody>
        </table>
      </div>
    );
  }

  onDayChange(val) {
    let { year, month, query, searchBy } = this.state;
    this.setState({ day: val.value });
    this.loadData(year, month, val.value, query, searchBy);
  }

  onMonthChange(val) {
    let { year, day, query, searchBy } = this.state;
    this.setState({ month: val.value });
    this.loadData(year, val.value, day, query, searchBy);
  }

  onYearChange(val) {
    let { month, day, query, searchBy } = this.state;
    this.setState({ year: val.value });
    this.loadData(val.value, month, day, query, searchBy);
  }

  onSearchClick() {
    let { year, month, day, query, searchBy } = this.state;
    this.loadData(year, month, day, query, searchBy);
  }

  onSearchOptionChange(e) {
    this.setState({ searchBy: e.value });
  }

  onSearchKeyPress(e) {
    if (e.charCode === 13) {
      let { year, month, day, query, searchBy } = this.state;
      this.loadData(year, month, day, query, searchBy);
    }
  }

  onQueryChange(e) {
    this.setState({ query: e.target.value });
  }

  onDateChange(item) {
    let { data, selectIndex, technician } = this.state;

    technician.fixing_order_date = item.value;
    data.dataList[selectIndex].fixing_order_date = item.value;

    this.setState({ data: data });
  }

  renderToolbar() {
    return (
      <Form inline>
        <FormGroup>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
          />
        </FormGroup>{" "}
        <FormGroup style={{ marginBottom: "5px" }}>
          <Select
            value={this.state.searchBy}
            options={searchOptions}
            clearable={false}
            onChange={this.onSearchOptionChange.bind(this)}
            style={{ width: "180px" }}
          />
        </FormGroup>{" "}
        <FormGroup style={{ marginBottom: "5px" }}>
          <div className="input-group">
            <FormControl
              value={this.state.query}
              placeholder="ค้นหา..."
              onKeyPress={this.onSearchKeyPress.bind(this)}
              onChange={this.onQueryChange.bind(this)}
              style={{ zIndex: "0" }}
            />
            <span className="input-group-btn" style={{ zIndex: "0" }}>
              <Button
                className="btn-flat"
                onClick={this.onSearchClick.bind(this)}
              >
                <FontAwesome name="search" />
              </Button>
            </span>
          </div>
        </FormGroup>
      </Form>
    );
  }

  render() {
    let { loading } = this.state;
    return (
      <div>
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>ตารางใบเสนอราคาช่าง</Box.Title>
          </Box.Header>
          <Box.Body>
            <div style={{ display: this.state.showBox }}>
              {this.renderToolbar()}
              {this.renderTable()}
            </div>

            <FixingOrderDoc
              show={this.state.showFixing}
              workNo={this.state.workNo}
              onBack={this.onFixingBack.bind(this)}
              technician={this.state.technician}
              onDateChange={this.onDateChange.bind(this)}
            />
          </Box.Body>
        </Box>
      </div>
    );
  }
}

export default ReportFixingOrderPage;



// WEBPACK FOOTER //
// ./src/view/report/ReportFixingOrderPage.js